import * as React from 'react';
import { Textarea as FluentTextarea, type TextareaProps as FluentTextareaProps } from '@fluentui/react-components';

export type TextareaProps = Omit<FluentTextareaProps, 'size'> & {
  size?: 'default' | 'sm' | 'lg';
};

function mapSize(size?: TextareaProps['size']): FluentTextareaProps['size'] {
  switch (size) {
    case 'sm':
      return 'small';
    case 'lg':
      return 'large';
    case 'default':
    default:
      return 'medium';
  }
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ size = 'default', className, resize, ...rest }, ref) => {
    return (
      <FluentTextarea
        size={mapSize(size)}
        resize={resize}
        className={className}
        ref={ref}
        {...rest}
      />
    );
  }
);

Textarea.displayName = 'Textarea';


